import { useState } from "react";
import { criminalTypes } from "@/mocks/lawfirm";

export default function CriminalAreas() {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <p className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-medium text-primary-700 tracking-wide">
            <i className="ri-layout-grid-line"></i>
            CRIMINAL AREAS
          </p>
          <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            형사사건 <span className="text-accent-600">전문 분야</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600">
            광주판사·검사출신변호사가 다루는 형사 전문 분야를 소개합니다.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {criminalTypes.map((t, idx) => {
            const isOpen = expandedId === t.id;
            return (
              <div
                key={t.id}
                className="group relative rounded-lg bg-white border border-background-200 p-6 hover:border-accent-400/50 transition-colors"
              >
                <button
                  type="button"
                  onClick={() => toggle(t.id)}
                  aria-label={`${t.title} 상세 내용 ${isOpen ? "접기" : "펼치기"}`}
                  aria-expanded={isOpen}
                  className="absolute inset-0 z-10 rounded-lg cursor-pointer md:hidden"
                ></button>

                <div className="flex items-center justify-between">
                  <span className="flex items-center justify-center w-12 h-12 rounded-md bg-primary-50 text-primary-600">
                    <i className={`${t.icon} text-xl`}></i>
                  </span>
                  <span className="flex items-center gap-2">
                    <span className="font-heading text-3xl font-bold text-background-200 group-hover:text-accent-200 transition-colors">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <span
                      className={`md:hidden flex items-center justify-center w-7 h-7 rounded-full bg-background-100 text-foreground-500 transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-lg"></i>
                    </span>
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-900">{t.title}</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{t.desc}</p>
                <ul className={`mt-4 space-y-2 ${isOpen ? "block" : "hidden"} md:block`}>
                  {t.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-xs md:text-sm text-foreground-700">
                      <i className="ri-arrow-right-s-line text-accent-500"></i>
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}